import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { environment } from "projects/ert/src/environments/environment";
import { RamTargetTurbine } from "projects/tilmanagement/src/app/interfaces/ram-targets/ramTargets";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "projects/tilmanagement/src/environments/environment";
import { MasterData } from "../../interfaces/ram-targets/masterData";
const apiHost = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class RamTargetsService {
  newRamTarget: RamTargetTurbine;
  addRamTargetForm: FormGroup;

  currentRamTarget: RamTargetTurbine;

  constructor(private httpClient: HttpClient, private fb: FormBuilder) {
    this.addRamTargetForm = this.fb.group({
      id: [0],
      turbineID: [0],
      serialNumber: [""],
      targetType: [""],
      jan: [0],
      feb: [0],
      mar: [0],
      apr: [0],
      may: [0],
      jun: [0],
      jul: [0],
      aug: [0],
      sep: [0],
      oct: [0],
      nov: [0],
      dec: [0],
      comments: [""],
    });
  }
  public setRamTarget(data: RamTargetTurbine) {
    this.newRamTarget = { ...this.newRamTarget, ...data };
  }

  public getRamTargetsDataAsync(
    plantId: number,
    metricId: string,
    year: number,
    activeStatus: boolean,
    inactiveStatus: boolean
  ) {
    return this.httpClient.get<RamTargetTurbine[]>(
      `${apiHost}/ram-targets/${year}/${metricId}/${plantId}/${activeStatus}/${inactiveStatus}`
    );
  }

  public addRamTarget() {
    return this.httpClient.post(`${apiHost}/ram-targets`, this.newRamTarget);
  }

  public updateRamTarget(ramTarget: RamTargetTurbine) {
    return this.httpClient.put(`${apiHost}/ram-targets`, ramTarget);
  }

  public getMasterData() {
    return this.httpClient.get<MasterData>(
      `${apiHost}/ram-targets/getMasterData`
    );
  }
}
